module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.communityApplication.user.nickname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedCommunityApplicationStatus)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Community application actions"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button",
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.communityApplication.user.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-plus",
      "yes-class": "btn btn-success",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('community.application.confirm.accept'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "size": "sm",
      "disabled": _vm.isCommunityApplicationProcessed
    },
    on: {
      "click": function($event) {
        _vm.processCommunityApplication(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.accept')) + "\n        ")])], 1), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-times",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('community.application.confirm.deny'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": _vm.isCommunityApplicationProcessed
    },
    on: {
      "click": function($event) {
        _vm.processCommunityApplication(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.deny')) + "\n        ")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c04868d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityApplicationsRow.vue
// module id = 562
// module chunks = 0